import store from '../store'

function requireBusinessAdmin(_to, _from, next) {
  const user = store.getters['auth/user']
  // A supervisor tradie with zero assigned projects is treated like a
  // non-supervisor tradie here — nothing on this tab would render for them
  // anyway (see isActiveSupervisorTradie).
  const isActiveSupervisorTradie =
    store.getters['auth/isActiveSupervisorTradie']
  if (
    !user ||
    (user.user_type !== 'business_admin' && !isActiveSupervisorTradie)
  ) {
    return next({ name: 'home.welcome-page' })
  }
  next()
}

export default {
  path: '/timesheets',
  name: 'timesheets.index',
  redirect: { name: 'timesheets.list-page' },
  component: () =>
    import(/* webpackChunkName: "timesheets" */ '@/views/timesheets/index.vue'),
  beforeEnter: requireBusinessAdmin,
  children: [
    {
      path: '/timesheets',
      name: 'timesheets.list-page',
      component: () => import('@/views/timesheets/TimesheetsPage.vue'),
    },
  ],
}
